export default "__VITE_ASSET__D_cwv91E__"